import { render, staticRenderFns } from "./DownloaderComponent.vue?vue&type=template&id=5783fdbe&"
import script from "./DownloaderComponent.vue?vue&type=script&lang=js&"
export * from "./DownloaderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports